var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcOutlineFolderSharedCircle54Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 27C0 12.0883 12.0883 0 27 0V0C41.9117 0 54 12.0883 54 27V27C54 41.9117 41.9117 54 27 54V54C12.0883 54 0 41.9117 0 27V27Z",
    fill: "#0033AD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35 21H27L25 19H19C17.9 19 17.01 19.9 17.01 21L17 33C17 34.1 17.9 35 19 35H35C36.1 35 37 34.1 37 33V23C37 21.9 36.1 21 35 21ZM35 33H19V21H24.17L26.17 23H35V33ZM30 28C31.1 28 32 27.1 32 26C32 24.9 31.1 24 30 24C28.9 24 28 24.9 28 26C28 27.1 28.9 28 30 28ZM26 32H34V31C34 29.67 31.33 29 30 29C28.67 29 26 29.67 26 31V32Z",
    fill: "#FFFFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcOutlineFolderSharedCircle54Px);
export default __webpack_public_path__ + "static/media/ic_outline-folder_shared_circle-54px.4bfc4f60056c45db78770847315afae5.svg";
export { ForwardRef as ReactComponent };